module.exports = __webpack_public_path__ + "img/plan_c4.4076c936.webp";